const state = {
  user: {
    username: '',
    email: '',
    authorities: []
  }
}

export default state
